import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { useEffect } from 'react';

import { getRunbookViewedKey } from './use-get-runbook-viewed';

import type { IRunbookViewedResponse } from './use-get-runbook-viewed';

export interface ISetRunbookViewedResponse {
  message: string;
}

const url = 'core-2/clinics/clinics-instructions-viewed';
const mutationFn = async (clinicGuid: string) => {
  const { data, error } =
    await dataService.createOne<ISetRunbookViewedResponse>(url, { clinicGuid });

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useSetRunbookViewed = () => {
  const queryClient = useQueryClient();

  const {
    mutate: setRunbookViewed,
    isLoading,
    error,
  } = useMutation<
    ISetRunbookViewedResponse | undefined,
    string | undefined,
    string
  >({
    mutationFn,
    onSuccess(data, clinicGuid) {
      const queryKey = getRunbookViewedKey(clinicGuid);
      queryClient.setQueryData<IRunbookViewedResponse>(queryKey, (old) => {
        if (!old) return old;

        old.exists = true;

        return old;
      });
    },
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { setRunbookViewed, setRunbookViewedLoading: isLoading };
};
